<template>
  <div>
    <b-row>
      <b-col v-for="(item, index) in items" :key="index" cols="12" md="6" lg="4" class="text-center pb-2">
        <div class="text-start">{{ item.chartOfAccountsTypeDescription }}</div>
        <p-advanced-select
          data-type="chartOfAccounts"
          v-model="item.chartOfAccountsId"
          :filter="filterChartOfAccounts"
          :additionalFilterParameter="item"
          class="full-width-select"
          @change="$emit('change')"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    emits: ['change'],
    props: {
      items: {
        type: Array,
        required: true
      },
      fields: {
        type: Array,
        required: true
      }
    },
    methods: {
      filterChartOfAccounts(chartOfAccount, item) {
        return chartOfAccount.type === item.chartOfAccountsTypeDescription || chartOfAccount.type == null;
      }     
    }
  };
</script>

<style scoped>
  .text-center {
    text-align: center;
  }
  .text-start {
    text-align: left;
  }
  .full-width-select {
    width: 100%;
    box-sizing: border-box;
    padding-right: 10px;
    margin-bottom: 15px;
  }
</style>